var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _g2, _path123, _g3, _path124, _g4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainLoginIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 631 461",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.63 81.2534C144.067 81.2534 162.255 63.0644 162.255 40.627C162.255 18.189 144.067 0 121.63 0C99.1884 0 81 18.189 81 40.627C81 63.0644 99.1884 81.2534 121.63 81.2534Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126:84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.749 58.6618H114.777V60.9165H141.749V58.6618Z",
    fill: "#03B599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.91 21H139.411C140.831 21 142 22.1691 142 23.5887V38.8706C142 40.2902 140.831 41.4593 139.411 41.4593H127.386L122.793 46.0522V41.4593H105.006C103.587 41.4593 102.418 40.2902 102.418 38.8706V23.5887C102.418 22.1691 103.587 21 105.006 21H124.965H138.91Z",
    fill: "#03A38A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.048 58.9958H137.324C138.326 58.9958 139.328 58.1608 139.578 57.2422L141.916 48.4739C142.167 47.4718 141.582 46.7202 140.58 46.7202H128.388C127.386 46.7202 126.384 47.5553 126.134 48.4739L123.795 57.2422C123.461 58.1608 124.046 58.9958 125.048 58.9958Z",
    fill: "#06594C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.864 41.2923C116.864 43.881 114.777 45.9687 112.188 45.9687C109.599 45.9687 107.511 43.881 107.511 41.2923C107.511 38.7036 109.599 36.6159 112.188 36.6159C114.777 36.6159 116.864 38.7036 116.864 41.2923Z",
    fill: "#03CFAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.1 60.666L113.608 53.8184L117.866 58.9123H127.136V57.0751L120.539 55.9895L114.944 48.5574C114.944 48.5574 109.766 44.215 107.511 48.3069L102 60.666H110.1Z",
    fill: "#03CFAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.768 27.1795H133.733",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.768 30.9374H133.733",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.768 34.6117H127.971",
    stroke: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M311.999 460.087C453.386 460.087 568 457.159 568 453.547C568 449.936 453.386 447.007 311.999 447.007C170.615 447.007 56 449.936 56 453.547C56 457.159 170.615 460.087 311.999 460.087Z",
    fill: "#07A98F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M378.622 52H143.765C140.276 52 137.448 54.8284 137.448 58.317V212.911C137.448 216.4 140.276 219.228 143.765 219.228H378.622C382.111 219.228 384.939 216.4 384.939 212.911V58.317C384.939 54.8284 382.111 52 378.622 52Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M373.353 160.918H329.594C327.97 160.918 326.655 162.234 326.655 163.857V211.347C326.655 212.97 327.97 214.286 329.594 214.286H373.353C374.977 214.286 376.292 212.97 376.292 211.347V163.857C376.292 162.234 374.977 160.918 373.353 160.918Z",
    fill: "url(#paint0_linear_126:84)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.967 160.418H147.673C146.299 160.418 145.184 161.532 145.184 162.907V211.797C145.184 213.172 146.299 214.286 147.673 214.286H210.967C212.341 214.286 213.456 213.172 213.456 211.797V162.907C213.456 161.532 212.341 160.418 210.967 160.418Z",
    fill: "url(#paint1_linear_126:84)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M318.821 160.418H221.601C219.91 160.418 218.539 161.789 218.539 163.48V211.224C218.539 212.915 219.91 214.286 221.601 214.286H318.821C320.512 214.286 321.883 212.915 321.883 211.224V163.48C321.883 161.789 320.512 160.418 318.821 160.418Z",
    fill: "url(#paint2_linear_126:84)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M372.364 73.8413H284.331C282.161 73.8413 280.402 75.6003 280.402 77.7701V151.684C280.402 153.853 282.161 155.612 284.331 155.612H372.364C374.534 155.612 376.292 153.853 376.292 151.684V77.7701C376.292 75.6003 374.534 73.8413 372.364 73.8413Z",
    fill: "url(#paint3_linear_126:84)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.059 240.207C268.44 234.262 266.915 232.671 269.438 229.16C271.915 225.738 271.369 215.66 273.735 217.581C276.099 219.501 276.113 223.109 276.113 223.109C278.71 220.313 281.81 214.768 286.346 215.131C290.882 215.493 290.94 216.962 292.935 219.588C298.221 226.647 287.845 232.888 285.692 235.693C284.319 237.446 276.254 241.864 275.205 243.001L270.71 247.048L263.059 240.207Z",
    fill: "#FFCCB3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M280.402 224.58L288.078 216.012",
    stroke: "#EF6A77",
    strokeWidth: 1.07832,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M283.514 227.006L291.508 219.228",
    stroke: "#EF6A77",
    strokeWidth: 1.07832,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M287.242 229.757L291.885 225",
    stroke: "#EF6A77",
    strokeWidth: 1.07832,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M182.465 288.304L137.448 449.906H146.618L198.651 288.304H182.465Z",
    fill: "#026B5B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M182.465 288.304L179.16 300.169L196.409 295.27L198.651 288.304H182.465Z",
    fill: "#5CA4E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M502.343 416.977L477.956 449.397C477.383 450.161 476.527 450.665 475.584 450.799C474.636 450.932 473.674 450.685 472.914 450.11L470.648 448.408L499.365 410.229L501.631 411.931C502.396 412.506 502.897 413.36 503.031 414.307C503.166 415.253 502.921 416.214 502.343 416.977Z",
    fill: "#5661AE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M479.341 397.993L488.131 405.139L479.202 418.922L469.286 411.355L479.341 397.993Z",
    fill: "#BC775C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M483.243 401.475L472.293 413.42L469.628 411.318L479.885 398.716L483.243 401.475Z",
    fill: "#93523E",
    stroke: "#93523E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M486.953 404.252C486.953 404.252 484.484 412.935 476.349 417.383L469.002 446.106C469.238 447.755 471.081 448.814 472.303 449.207C472.572 449.291 472.861 449.29 473.13 449.203C473.4 449.117 473.631 448.949 473.799 448.722L499.87 414.066C500.303 413.488 500.496 412.762 500.404 412.044C500.308 411.327 499.938 410.675 499.365 410.229C497.09 408.443 493.592 405.751 492.081 404.827C489.738 403.398 488.074 403.068 486.953 404.252Z",
    fill: "#1C85E8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M474.651 423.339L478.831 422.443C478.985 422.41 479.144 422.415 479.293 422.458C479.442 422.501 479.577 422.58 479.693 422.689C479.803 422.797 479.89 422.931 479.938 423.08C479.986 423.228 479.996 423.387 479.967 423.54C479.933 423.729 479.847 423.903 479.712 424.04C479.577 424.177 479.409 424.27 479.221 424.308L474.088 425.344L474.651 423.339Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M473.664 427.891L477.821 426.984C477.975 426.951 478.134 426.956 478.283 426.999C478.432 427.042 478.572 427.121 478.682 427.23C478.798 427.338 478.88 427.473 478.928 427.621C478.976 427.77 478.985 427.928 478.961 428.081C478.928 428.27 478.836 428.444 478.702 428.581C478.572 428.718 478.398 428.812 478.211 428.85L473.15 429.899L473.664 427.891Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M472.394 432.846L476.508 431.927C476.662 431.895 476.82 431.9 476.97 431.943C477.119 431.985 477.258 432.064 477.369 432.173C477.479 432.281 477.566 432.416 477.614 432.564C477.662 432.713 477.672 432.871 477.643 433.025C477.609 433.213 477.523 433.387 477.388 433.524C477.253 433.661 477.085 433.754 476.897 433.792L471.894 434.802L472.394 432.846Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M395.764 360.211L465.365 416.286L481.242 397.782L420.387 340.689L395.764 360.211Z",
    fill: "#1F2D49"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M433.096 352.612V390.288L465.365 416.286L469.998 387.233L433.096 352.612Z",
    fill: "#0D1B33"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M401.941 257.12L390.5 348.351H422.487L450.273 257.577L401.941 257.12Z",
    fill: "#1F2D49"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M429.406 325.75L434.779 280.491H447.988L429.406 325.75Z",
    fill: "#0D1B33"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M458.12 451.471H417.552C416.596 451.471 415.679 451.091 415.004 450.415C414.328 449.739 413.948 448.823 413.948 447.867V445.034H461.723V447.867C461.723 448.823 461.343 449.739 460.67 450.415C459.991 451.091 459.077 451.471 458.12 451.471Z",
    fill: "#5661AE"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M459.462 421.674L459.039 432.997L442.653 434.144L442.741 421.674H459.462Z",
    fill: "#BC775C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M459.029 426.889L442.898 425.317L442.975 421.924L459.212 422.545L459.029 426.889Z",
    fill: "#93523E",
    stroke: "#93523E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M459.039 431.523C459.039 431.523 450.614 434.768 442.17 430.942L414.798 442.336C413.621 443.514 413.882 445.622 414.305 446.837C414.399 447.103 414.573 447.333 414.804 447.496C415.035 447.658 415.31 447.745 415.592 447.743H458.957C459.683 447.744 460.376 447.46 460.896 446.954C461.411 446.447 461.709 445.758 461.723 445.035C461.781 442.139 461.829 437.728 461.661 435.963C461.396 433.234 460.655 431.703 459.039 431.523Z",
    fill: "#1C85E8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M436.387 433.163L439.617 435.965C439.735 436.068 439.826 436.198 439.882 436.343C439.938 436.489 439.957 436.646 439.938 436.801C439.919 436.956 439.862 437.104 439.772 437.232C439.683 437.36 439.563 437.463 439.424 437.534C439.253 437.621 439.06 437.654 438.871 437.63C438.681 437.605 438.503 437.524 438.36 437.397L434.446 433.918L436.387 433.163Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M432.156 435.11L435.382 437.889C435.499 437.992 435.59 438.121 435.647 438.267C435.703 438.413 435.722 438.57 435.703 438.725C435.684 438.88 435.627 439.028 435.537 439.156C435.448 439.284 435.328 439.387 435.189 439.458C435.018 439.545 434.825 439.578 434.635 439.554C434.445 439.529 434.267 439.448 434.124 439.321L430.242 435.907L432.156 435.11Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M427.435 437.076L430.641 439.81C430.759 439.912 430.85 440.042 430.906 440.187C430.962 440.333 430.981 440.49 430.962 440.646C430.943 440.801 430.886 440.948 430.796 441.076C430.707 441.204 430.587 441.308 430.448 441.379C430.277 441.466 430.084 441.499 429.895 441.474C429.705 441.45 429.527 441.369 429.384 441.241L425.571 437.852L427.435 437.076Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M469.681 257.577C469.416 262.203 469.416 266.841 469.681 271.468C470.744 286.422 467.343 330.094 467.372 335.84C467.396 341.587 463.614 422.525 463.614 422.525H440.615C440.615 422.525 434.737 352.966 434.6 345.005C434.465 337.045 433.096 257.904 433.096 257.904L469.681 257.577Z",
    fill: "#1F2D49"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M401.248 262.644L469.681 271.468V257.577L401.603 259.816L401.248 262.644Z",
    fill: "#0D1B33"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M406.494 364.345C415.327 364.345 422.488 357.184 422.488 348.351C422.488 339.518 415.327 332.357 406.494 332.357C397.661 332.357 390.501 339.518 390.501 348.351C390.501 357.184 397.661 364.345 406.494 364.345Z",
    fill: "#1F2D49"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M525.682 280.491H105.79V288.304H525.682V280.491Z",
    fill: "url(#paint4_linear_126:84)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.278 441.681C301.074 439.489 294.679 437.229 288.784 437.648C288.651 437.657 288.522 437.695 288.405 437.759C288.288 437.822 288.186 437.911 288.107 438.018C288.028 438.125 287.973 438.248 287.946 438.378C287.919 438.509 287.92 438.644 287.95 438.773L290.419 449.203C290.47 449.418 290.597 449.607 290.776 449.735C290.956 449.864 291.176 449.923 291.396 449.902L331.477 446.031C334.433 445.746 335.859 443.996 336.07 441.584C336.076 441.501 336.058 441.419 336.018 441.346C335.978 441.273 335.918 441.214 335.845 441.174C335.772 441.135 335.689 441.117 335.606 441.124C335.523 441.13 335.444 441.16 335.378 441.211C330.955 444.527 325.41 445.982 319.929 445.263C315.972 444.753 311.673 443.234 307.278 441.681Z",
    fill: "#5661AE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.596 411.589C285.596 411.589 289.731 427.978 289.846 429.737C289.857 430.714 289.794 431.691 289.661 432.659C289.476 434.4 289.271 436.339 289.58 437.611C295.252 437.435 301.353 439.59 307.278 441.683C311.673 443.235 315.971 444.754 319.928 445.263C325.145 445.947 330.43 444.665 334.753 441.665C334.572 438.672 331.734 436.149 326.498 436.2C317.113 436.291 311.919 436.122 306.742 429.803C303.062 425.312 301.287 406.369 301.287 406.369L285.596 411.589Z",
    fill: "#FFCCB3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.544 427.186C303.815 427.591 296.935 429.17 290.223 430.263C288.918 430.475 288.505 433.169 289.49 434.508C290.17 435.498 290.769 436.541 291.28 437.626C293.619 437.765 295.937 438.145 298.197 438.76C297.005 436.205 298.28 434.533 300.738 433.929C302.68 433.451 307.365 433.37 309.79 433.361C309.923 433.361 310.053 433.322 310.166 433.25C310.277 433.177 310.366 433.075 310.422 432.953C310.477 432.832 310.497 432.697 310.478 432.566C310.46 432.434 310.403 432.31 310.317 432.209L306.234 427.413C306.152 427.316 306.043 427.243 305.921 427.202C305.8 427.162 305.669 427.157 305.544 427.186Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.092 444.102C325.8 445.765 322.798 445.419 322.798 445.419L321.883 435.94L329.268 435.569L330.092 444.102Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M281.691 345.463C288.811 343.328 292.851 335.825 290.715 328.706C288.58 321.587 281.078 317.547 273.958 319.682C266.839 321.817 262.799 329.32 264.934 336.439C267.069 343.559 274.572 347.599 281.691 345.463Z",
    fill: "#FFCCB3"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M281.807 319.716L259.497 312.079L249.112 340.054L277.974 345.079L281.807 319.716Z",
    fill: "#FFCCB3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M291.165 330.785L302.491 415.422L287.799 420.505L265.59 340.145L291.165 330.785Z",
    fill: "#FFCCB3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.644 447.549C238.783 444.558 232.742 441.474 226.843 441.112C226.71 441.103 226.576 441.124 226.452 441.172C226.328 441.219 226.216 441.294 226.123 441.389C226.03 441.485 225.959 441.6 225.915 441.725C225.872 441.851 225.855 441.985 225.868 442.118L226.94 452.782C226.962 453.001 227.062 453.206 227.223 453.357C227.384 453.508 227.594 453.595 227.815 453.603L268.058 455.053C271.024 455.16 272.669 453.613 273.197 451.25C273.214 451.169 273.206 451.084 273.177 451.007C273.146 450.929 273.094 450.863 273.027 450.814C272.96 450.765 272.88 450.737 272.797 450.732C272.714 450.728 272.632 450.748 272.56 450.789C267.738 453.493 262.05 454.203 256.711 452.767C252.855 451.741 248.795 449.668 244.644 447.549Z",
    fill: "#5661AE"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.119 414.86C227.119 414.86 229.057 431.652 228.94 433.41C228.82 434.38 228.63 435.34 228.37 436.283C227.958 437.983 227.498 439.878 227.637 441.18C233.283 441.753 239.045 444.694 244.643 447.551C248.795 449.67 252.855 451.741 256.711 452.768C261.792 454.134 267.199 453.56 271.88 451.157C272.096 448.166 269.615 445.291 264.418 444.651C255.103 443.503 249.977 442.651 245.678 435.704C242.623 430.767 243.362 411.755 243.362 411.755L227.119 414.86Z",
    fill: "#FCBA9F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M244.836 432.951C243.069 433.125 236.041 433.783 229.243 433.981C227.922 434.02 227.157 436.635 227.958 438.093C228.5 439.163 228.956 440.276 229.32 441.42C231.62 441.865 233.868 442.548 236.027 443.456C235.182 440.766 236.667 439.277 239.183 439.001C241.17 438.784 245.826 439.322 248.231 439.633C248.363 439.65 248.497 439.629 248.617 439.572C248.738 439.515 248.84 439.425 248.91 439.312C248.982 439.199 249.019 439.069 249.018 438.936C249.017 438.802 248.977 438.672 248.905 438.56L245.491 433.269C245.421 433.161 245.324 433.074 245.208 433.018C245.093 432.962 244.964 432.939 244.836 432.951Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.939 452.958C262.465 454.04 259.535 453.302 259.535 453.302L259.878 443.784L267.248 444.391L266.939 452.958Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M231.97 348.797C239.309 347.619 244.303 340.715 243.126 333.377C241.948 326.038 235.044 321.043 227.705 322.221C220.366 323.399 215.372 330.303 216.55 337.642C217.727 344.98 224.631 349.975 231.97 348.797Z",
    stroke: "#5CA4E6",
    strokeWidth: 1.0969,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M243.297 335.497L243.361 420.888L228.128 423.989L216.711 341.402L243.297 335.497Z",
    fill: "#FCBA9F"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M203.419 304.32C203.419 304.32 199.323 324.364 204.69 332.74C211.485 343.341 219.794 344.965 225.935 345.079L259.113 342.217C259.113 342.217 258.894 323.141 271.182 316.014C271.182 316.014 220.82 297.427 203.419 304.32Z",
    fill: "#3531A1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M190.647 202.062L188.011 215.522L172.758 214.487L175.68 200.18L190.647 202.062Z",
    fill: "#FFCCB3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M190.493 202.845L189.213 209.384C189.213 209.384 185.708 206.396 185.031 201.733L190.493 202.845Z",
    fill: "#FCBA9F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M168.056 218.314C168.056 218.314 171.53 209.25 173.603 210.35C178.531 212.966 185.728 212.481 188.914 210.909C190.824 209.967 190.896 218.314 190.896 218.314H168.056Z",
    fill: "#FEBB94"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M168.056 218.314L153.419 220.275C153.017 220.329 152.652 220.537 152.402 220.856C152.151 221.174 152.034 221.578 152.077 221.981L162.297 318.933L214.737 313.785L208.247 221.528L190.896 218.314H168.056Z",
    fill: "url(#paint5_linear_126:84)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M205.373 245.939L201.283 238.5L202.29 245.939H205.373Z",
    fill: "#FF967C"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M207.337 221.359C212.867 222.207 217.503 225.892 219.051 229.112L232.731 260.276L266.323 233.41L275.873 243.469L245.677 280.775C239.604 288.772 229.1 292.063 221.946 281.634L210.516 263.681L207.337 221.359Z",
    fill: "url(#paint6_linear_126:84)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M232.731 260.276L236.553 267.789L239.462 254.892L232.731 260.276Z",
    fill: "url(#paint7_linear_126:84)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M153.531 220.26C153.531 220.26 149.581 220.19 146.26 226.001C142.939 231.812 129.49 267.012 129.49 267.012C129.49 267.012 123.347 280.295 135.8 280.793H161.867L153.531 220.26Z",
    fill: "url(#paint8_linear_126:84)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M156.472 245.939L155.381 241.064L152.634 245.939H156.472Z",
    fill: "#FF967C"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M225.432 345.045H168.503C166.71 345.045 164.977 344.398 163.622 343.223C162.268 342.049 161.382 340.425 161.129 338.65L149.098 254.442C148.947 253.385 149.025 252.308 149.326 251.285C149.627 250.261 150.146 249.314 150.845 248.508C151.544 247.701 152.408 247.055 153.379 246.612C154.35 246.168 155.405 245.939 156.472 245.939H213.402C215.194 245.939 216.927 246.586 218.282 247.761C219.636 248.935 220.522 250.56 220.775 252.334L232.806 336.543C232.957 337.599 232.879 338.676 232.578 339.7C232.277 340.724 231.759 341.67 231.059 342.477C230.36 343.283 229.496 343.93 228.525 344.373C227.554 344.816 226.499 345.045 225.432 345.045Z",
    fill: "#7AFFEA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M221.595 345.045H265.193C265.568 345.045 265.936 344.946 266.259 344.758C266.583 344.57 266.851 344.3 267.037 343.975C267.223 343.65 267.319 343.282 267.316 342.907C267.314 342.532 267.212 342.166 267.022 341.844C266.873 341.591 266.674 341.373 266.437 341.202C266.2 341.03 265.93 340.91 265.644 340.848L230.351 333.175L221.595 345.045Z",
    fill: "#7AFFEA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M221.595 345.045H164.665C162.872 345.045 161.139 344.398 159.785 343.223C158.43 342.049 157.545 340.425 157.292 338.65L145.261 254.442C145.11 253.385 145.188 252.308 145.489 251.285C145.79 250.261 146.308 249.314 147.007 248.508C147.706 247.701 148.571 247.055 149.542 246.612C150.513 246.168 151.567 245.939 152.634 245.939H209.564C211.357 245.939 213.09 246.586 214.445 247.761C215.799 248.935 216.684 250.56 216.938 252.334L228.969 336.543C229.12 337.599 229.042 338.676 228.741 339.7C228.439 340.724 227.922 341.67 227.223 342.477C226.523 343.283 225.659 343.93 224.688 344.373C223.717 344.816 222.662 345.045 221.595 345.045Z",
    fill: "url(#paint9_linear_126:84)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M454.098 267.655C454.098 267.655 451.023 273.463 450.273 274.13C449.527 274.796 437.171 276.32 434.779 277.177C432.386 278.034 431.244 279.329 431.244 280.491H460.285C460.285 280.491 461.035 279.79 461.579 277.557C462.118 275.325 463.066 274.378 463.066 274.378L454.098 267.655Z",
    fill: "#BC775C"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M412.354 176.149C414.264 166.721 409.772 166.964 408.277 165.465C408.277 165.465 402.67 160.84 398.397 165.151C393.874 169.71 367.948 205.129 367.948 205.129L384.17 220.049L387.219 216.411L395.118 206.99L403.566 196.922L404.615 195.776L416.012 182.867C416.012 182.867 411.274 181.114 412.354 176.149Z",
    fill: "#3531A1"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M419.138 177.756C421.325 171.228 417.805 164.162 411.277 161.976C404.748 159.789 397.682 163.309 395.495 169.837C393.309 176.366 396.829 183.432 403.358 185.618C409.886 187.805 416.952 184.285 419.138 177.756Z",
    fill: "#3531A1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M404.466 195.726C404.793 193.755 405.448 189.813 406.151 186.221L409.894 168.835C409.894 168.835 399.842 183.692 395.211 194.04C391.782 201.795 387.803 209.699 387.145 216.385L395.043 206.965L403.491 196.897L404.466 195.726Z",
    fill: "#1D1273"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M351.744 165.253C347.89 158.222 349.742 157.029 348.102 153.029C346.487 149.126 349.355 139.449 346.609 140.768C343.863 142.088 343.014 145.594 343.014 145.594C341.135 142.272 339.406 136.159 334.91 135.46C330.414 134.76 330.016 136.175 327.467 138.266C320.688 143.907 329.333 152.384 330.776 155.612C331.705 157.636 338.525 163.805 339.281 165.153L342.714 170.134L351.744 165.253Z",
    fill: "#BC775C"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M338.499 146.03L333.021 135.915",
    stroke: "#93523E",
    strokeWidth: 1.07832,
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M334.91 147.668L328.939 138.248",
    stroke: "#93523E",
    strokeWidth: 1.07832,
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M330.645 149.479L327.232 143.774",
    stroke: "#93523E",
    strokeWidth: 1.07832,
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M339.853 154.935C339.882 151.432 341.984 147.194 341.984 147.194",
    stroke: "#93523E",
    strokeWidth: 1.07832,
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M384.307 204.848L351.321 160.918C351.11 160.66 350.812 160.489 350.483 160.438C350.154 160.386 349.818 160.459 349.539 160.641L340.901 166.354C340.491 166.632 340.198 167.052 340.081 167.534C339.963 168.015 340.029 168.524 340.265 168.96L366.792 217.881L384.307 204.848Z",
    fill: "#3531A1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M376.292 223.402C382.393 223.402 387.339 218.456 387.339 212.355C387.339 206.254 382.393 201.309 376.292 201.309C370.192 201.309 365.246 206.254 365.246 212.355C365.246 218.456 370.192 223.402 376.292 223.402Z",
    fill: "#3531A1"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M422.448 155.534C422.448 155.534 406.342 160.658 403.165 161.987C399.987 163.316 399.775 168.633 399.563 172.399C399.415 175.038 402.393 218.37 402.589 243.465C402.631 248.827 401.631 252.229 400.989 255.208C400.347 258.188 400.989 259.81 400.989 259.81L469.998 260.427C469.998 260.427 467.93 173.232 467.506 170.131C467.083 167.03 470.412 164.358 466.804 162.797L440.452 155.534H422.448Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M413.788 158.331C413.788 158.331 416.417 170.359 418.14 179.985C419.863 189.611 420.387 269.3 420.387 269.3C420.387 269.3 400.222 265.379 397.49 260.747C394.759 256.113 400.02 235.298 400.43 216.385C400.839 197.473 396.858 168.122 401.038 163.03C401.038 163.031 402.11 161.968 413.788 158.331Z",
    fill: "#3531A1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M447.68 157.558C447.68 157.558 438.112 177.493 438.697 183.569C439.282 189.645 439.316 241.461 438.697 252.279C438.313 258.86 437.31 265.391 435.703 271.784C435.703 271.784 461.805 273.632 471.889 270.475C471.889 270.475 476.681 240.331 473.534 229.562C470.393 218.793 467.992 162.826 467.992 162.826L447.68 157.558Z",
    fill: "#3531A1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M454.742 184.348C454.742 184.348 455.719 220.476 455.517 232.519C455.392 240.023 446.809 243.201 446.785 247.546C446.77 250.117 453.559 247.108 455.392 249.765C457.22 252.422 454.093 260.747 454.093 260.747L469.998 260.427L476.373 229.507L462.945 182.488L454.742 184.348Z",
    fill: "#1D1273"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M422.779 147.482L421.285 164.319C421.285 164.319 420.887 166.934 425.429 167.762C429.036 168.419 436.531 164.18 438.223 162.784C441.983 159.681 442.331 157.803 441.933 156.365C441.364 154.305 439.504 139.785 439.504 139.785L422.779 147.482Z",
    fill: "#BC775C"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M421.798 161.261L422.718 150.883L430.736 146.923L421.798 161.261Z",
    fill: "#93523E",
    stroke: "#93523E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M413.867 115.614C413.867 115.614 410.796 129.37 410.387 138.739C409.975 148.191 413.352 149.991 417.54 150.697C420.843 151.254 425.98 151.294 429.211 149.681C435.102 146.739 444.774 139.599 446.04 138.214C448.002 136.069 447.867 126.503 440.38 124.137C434.936 122.416 421.053 107.808 413.867 115.614Z",
    fill: "#BC775C"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M413.897 117.081C418.363 118.832 426.769 117.681 431.387 119.18C435.997 120.683 431.802 122.269 432.003 126.723C432.132 129.609 432.352 135.122 434.122 135.049C435.893 134.976 436.936 128.715 440.669 128.953C444.402 129.197 446.163 130.791 446.081 133.179C446.001 135.562 443.318 137.639 441.201 138.742C438.552 140.114 437.458 139.539 437.458 139.539C437.458 139.539 440.44 150.517 440.89 150.083C440.89 150.083 444.107 148.267 444.687 145.09C444.687 145.09 448.955 144.165 448.012 139.896C448.012 139.896 450.667 139.043 449.407 136.572C449.407 136.572 456.277 131.952 452.698 126.299C452.698 126.299 455.955 123.049 452.063 121.674C452.063 121.674 457.22 114.139 449.883 112.533C449.883 112.533 450.374 108.986 447.016 109.121C447.016 109.121 445.55 103.021 438.222 105.427C438.187 104.205 437.784 103.022 437.065 102.034C436.346 101.046 435.345 100.298 434.194 99.8885C430.044 98.2172 427.343 100.517 427.343 100.517C427.343 100.517 422.987 96.9648 420.694 102.173C420.694 102.173 417.4 100.489 414.93 102.279C412.457 104.062 413.659 107.801 413.659 107.801C413.659 107.801 410.833 107.138 409.801 109.479C408.344 112.774 410.39 113.974 410.39 113.974C410.39 113.974 405.788 119.414 412.26 124.567L413.897 117.081Z",
    fill: "#493212"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M425.137 130.662C425.38 129.549 424.986 128.518 424.257 128.359C423.528 128.199 422.741 128.972 422.498 130.085C422.254 131.197 422.648 132.228 423.377 132.387C424.106 132.547 424.894 131.774 425.137 130.662Z",
    fill: "#080B09"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M415.108 128.403C415.351 127.291 414.957 126.26 414.228 126.1C413.499 125.941 412.711 126.714 412.468 127.826C412.225 128.939 412.619 129.97 413.348 130.129C414.077 130.288 414.865 129.516 415.108 128.403Z",
    fill: "#080B09"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M417.09 131.357C417.09 131.357 418.336 133.756 416.536 133.792C414.817 133.768 413.815 134.777 415.549 136.239",
    stroke: "#93523E",
    strokeWidth: 1.07832,
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M415.815 138.457L415.823 138.458L415.831 138.459C416.897 138.535 419.027 138.688 420.443 138.814H420.446C420.487 138.817 420.527 138.832 420.561 138.856C420.594 138.88 420.62 138.913 420.637 138.952C420.653 138.99 420.658 139.032 420.653 139.072C420.647 139.112 420.631 139.149 420.606 139.181C420.295 139.524 419.885 139.932 419.429 140.283C418.969 140.639 418.477 140.925 418.005 141.038C417.542 141.15 417.105 141.095 416.715 140.782C416.312 140.459 415.928 139.837 415.64 138.742L415.636 138.724L415.628 138.706C415.615 138.677 415.61 138.645 415.614 138.613C415.617 138.582 415.629 138.552 415.649 138.526C415.668 138.501 415.693 138.481 415.723 138.469C415.752 138.457 415.784 138.453 415.815 138.457Z",
    fill: "#93523E",
    stroke: "#93523E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M428.632 126.996L428.532 127.197C428.412 127.504 428.176 127.75 427.875 127.883C427.574 128.016 427.233 128.025 426.926 127.907L421.699 125.744C421.442 125.649 421.23 125.462 421.104 125.218C420.979 124.975 420.949 124.693 421.021 124.429C421.058 124.265 421.129 124.11 421.23 123.976C421.33 123.841 421.458 123.73 421.606 123.649C421.752 123.568 421.915 123.518 422.082 123.505C422.25 123.491 422.418 123.512 422.576 123.569L427.902 125.531C428.048 125.576 428.183 125.651 428.299 125.751C428.415 125.85 428.51 125.972 428.578 126.108C428.646 126.245 428.686 126.394 428.695 126.547C428.704 126.699 428.683 126.852 428.632 126.996Z",
    fill: "#080B09"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M410.998 122.13L416.661 121.749C416.829 121.739 416.996 121.765 417.153 121.826C417.31 121.887 417.452 121.98 417.57 122.099C417.688 122.218 417.78 122.362 417.839 122.519C417.897 122.676 417.922 122.844 417.911 123.012C417.906 123.286 417.798 123.548 417.609 123.746C417.42 123.944 417.163 124.064 416.889 124.083L411.266 124.685C410.938 124.712 410.613 124.608 410.362 124.395C410.111 124.183 409.953 123.88 409.924 123.552L409.885 123.331C409.877 123.179 409.899 123.026 409.951 122.882C410.003 122.738 410.083 122.606 410.187 122.494C410.29 122.382 410.416 122.292 410.556 122.23C410.695 122.167 410.845 122.134 410.998 122.13Z",
    fill: "#080B09"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M468.512 171.49C461.401 165.007 459.303 168.985 457.249 169.498C457.249 169.498 450.403 171.933 451.904 177.813C453.492 184.036 470.556 224.476 470.556 224.476L492.091 219.378L490.138 213.739L486.115 202.123L481.819 189.702L481.372 188.212L476.152 171.803C476.152 171.803 472.216 174.967 468.512 171.49Z",
    fill: "#3531A1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M472.014 184.073C477.244 179.595 477.855 171.725 473.376 166.495C468.897 161.264 461.026 160.654 455.796 165.132C450.566 169.61 449.955 177.48 454.435 182.71C458.914 187.94 466.78 188.551 472.014 184.073Z",
    fill: "#3531A1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M470.393 218.793L451.346 270.322C451.245 270.639 451.264 270.982 451.399 271.286C451.533 271.59 451.774 271.834 452.082 271.969L461.56 276.133C462.017 276.328 462.532 276.346 462.998 276.183C463.465 276.021 463.859 275.691 464.095 275.256L490.84 226.451L470.393 218.793Z",
    fill: "#3531A1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M481.045 232.508C487.145 232.508 492.091 227.562 492.091 221.461C492.091 215.36 487.145 210.414 481.045 210.414C474.944 210.414 469.998 215.36 469.998 221.461C469.998 227.562 474.944 232.508 481.045 232.508Z",
    fill: "#3531A1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M182.773 345.045H224.276C224.276 349.624 222.457 354.015 219.219 357.253C215.981 360.49 211.59 362.309 207.012 362.309H200.038C195.459 362.309 191.067 360.49 187.83 357.253C184.592 354.015 182.773 349.624 182.773 345.045Z",
    fill: "#03B599"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M204.446 362.309H202.603V445.297H204.446V362.309Z",
    fill: "#026B5B"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M202.603 445.297L177.306 453.494H229.351L204.446 445.297H202.603Z",
    fill: "#026B5B"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M120.423 288.304L75.4059 449.906H84.5763L136.609 288.304H120.423Z",
    fill: "#026B5B"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M120.423 288.304L117.118 300.169L134.366 295.27L136.609 288.304H120.423Z",
    fill: "#014439"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M504.186 288.304L549.203 449.906H540.033L487.997 288.304H504.186Z",
    fill: "#026B5B"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M504.186 288.304L506.712 297.375L490.33 295.546L487.997 288.304H504.186Z",
    fill: "#06A288"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M191.339 173.528C191.339 173.528 197.392 184.451 199.492 188.959C201.591 193.466 202.309 198.329 198.813 200.568C194.055 203.614 188.791 202.937 183.118 202.303C178.207 201.754 172.053 187.935 172.807 184.542C173.561 181.15 182.101 167.541 191.339 173.528Z",
    fill: "#FFCCB3"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M195.852 186.048C196.294 185.691 196.225 184.876 195.7 184.226C195.174 183.577 194.392 183.339 193.951 183.695C193.51 184.052 193.578 184.867 194.104 185.517C194.628 186.167 195.412 186.404 195.852 186.048Z",
    fill: "#080B09"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M189.332 184.387L193.951 181.102C193.838 180.972 193.699 180.866 193.543 180.792C193.387 180.718 193.217 180.678 193.044 180.673C192.871 180.669 192.7 180.701 192.54 180.767C192.381 180.834 192.237 180.932 192.118 181.057L189.058 184.159C188.949 184.247 189.169 184.519 189.332 184.387Z",
    fill: "#080B09"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M198.618 192.827C197.998 193.213 197.283 193.417 196.552 193.417C195.822 193.417 195.106 193.213 194.486 192.827",
    stroke: "#EF6A77",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M186.998 180.08L196.888 175.078C196.888 175.078 193.301 163.412 180.162 162.193C170.523 161.299 161.564 166.613 158.093 174.915C154.62 183.217 157.589 196.896 166.395 200.18C173.843 202.957 173.603 210.35 173.603 210.35L184.509 196.049C184.509 196.049 176.964 192.378 178.773 187.897C181.226 181.823 187.39 188.845 187.39 188.845L183.219 176.706L186.998 180.08Z",
    fill: "#1F2D49"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M197.45 184.871C197.45 184.871 199.099 187.021 200.098 187.435C201.095 187.85 200.202 189.377 199.537 189.589C198.872 189.801 197.071 185.886 197.45 184.871Z",
    fill: "#FFCCB3"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M156.677 196.59C163.149 196.59 168.396 191.344 168.396 184.871C168.396 178.4 163.149 173.153 156.677 173.153C150.205 173.153 144.958 178.4 144.958 184.871C144.958 191.344 150.205 196.59 156.677 196.59Z",
    fill: "#0D1B33"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M155.381 197.105C161.853 197.105 167.099 191.859 167.099 185.386C167.099 178.914 161.853 173.667 155.381 173.667C148.909 173.667 143.662 178.914 143.662 185.386C143.662 191.859 148.909 197.105 155.381 197.105Z",
    fill: "#1F2D49"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M270.322 73.8413H149.088C146.932 73.8413 145.184 75.5892 145.184 77.745V151.631C145.184 153.787 146.932 155.534 149.088 155.534H270.322C272.478 155.534 274.226 153.787 274.226 151.631V77.745C274.226 75.5892 272.478 73.8413 270.322 73.8413Z",
    fill: "url(#paint10_linear_126:84)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M229.045 172.025H235.527",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M249.794 172.025H310.152",
    stroke: "#00BA9C",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M229.045 186.222H235.527",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M249.794 186.222H277.896",
    stroke: "#00BA9C",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M229.045 200.668H235.527",
    stroke: "white",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M249.794 200.668H298.122",
    stroke: "#00BA9C",
    strokeWidth: 8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M153.766 117.67C153.766 117.67 164.449 115.42 167.837 120.616C171.226 125.811 174.614 135.571 182.295 134.306C189.976 133.04 193.683 107.512 201.363 107.738C209.043 107.964 207.822 124.682 216.18 124.908C224.538 125.134 222.209 115.564 227.789 115.826C234.559 116.143 233.8 135.977 242.61 136.203C251.42 136.429 250.517 109.999 263.845 110.45",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M157.172 86.2082H178.502",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M157.172 96.1624H201.251",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M328.348 128.593C336.005 128.593 342.214 122.385 342.214 114.727C342.214 107.069 336.005 100.861 328.348 100.861C320.689 100.861 314.481 107.069 314.481 114.727C314.481 122.385 320.689 128.593 328.348 128.593Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M324.058 110.909V119.71C324.058 119.954 324.121 120.194 324.242 120.406C324.363 120.618 324.537 120.795 324.746 120.919C324.956 121.044 325.195 121.111 325.439 121.116C325.683 121.12 325.924 121.061 326.138 120.943L334.183 116.543C334.404 116.422 334.588 116.244 334.717 116.027C334.846 115.81 334.914 115.562 334.914 115.31C334.914 115.057 334.846 114.81 334.717 114.593C334.588 114.376 334.404 114.198 334.183 114.076L326.138 109.676C325.924 109.559 325.683 109.5 325.439 109.504C325.195 109.508 324.956 109.576 324.746 109.7C324.537 109.825 324.363 110.001 324.242 110.214C324.122 110.426 324.058 110.665 324.058 110.909Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M525.682 280.491H456.556V288.304H525.682V280.491Z",
    fill: "#03B599"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M442.143 288.304L487.159 449.906H477.99L425.957 288.304H442.143Z",
    fill: "#026B5B"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M442.143 288.304L445.448 300.169L428.2 295.27L425.957 288.304H442.143Z",
    fill: "#06A288"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M143.96 52H378.427C380.154 52 381.81 52.6861 383.032 53.9076C384.253 55.1286 384.939 56.7851 384.939 58.5123V68.3226H137.448V58.5123C137.448 56.7851 138.134 55.1286 139.355 53.9076C140.576 52.6861 142.233 52 143.96 52Z",
    fill: "#007764"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6304 336.253C63.0667 336.253 81.2551 318.064 81.2551 295.627C81.2551 273.189 63.0667 255 40.6304 255C18.1884 255 0 273.189 0 295.627C0 318.064 18.1884 336.253 40.6304 336.253Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_126:84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.8399 312.842H24.0769V290.389C24.0769 289.058 25.158 287.977 26.4885 287.977H55.3451C56.6757 287.977 57.7567 289.058 57.7567 290.389V312.842H57.8399Z",
    fill: "#007E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2141 298.372L34.3056 300.95L34.1393 297.374C34.1393 296.376 34.4719 295.378 35.2204 294.63L37.7152 292.218L38.2141 298.372Z",
    fill: "#7AFFEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7858 298.372L47.6943 300.95L47.8607 297.374C47.8607 296.376 47.528 295.378 46.7796 294.63L44.2848 292.218L43.7858 298.372Z",
    fill: "#7AFFEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9584 298.206C42.0395 298.206 43.0374 298.372 44.0353 298.622C44.7838 295.96 45.1996 293.05 45.1996 289.973C45.1996 283.985 43.5364 280.992 40.9584 277.083C38.3804 280.992 36.7172 283.985 36.7172 289.973C36.7172 293.05 37.133 295.96 37.8815 298.622C38.8794 298.372 39.9605 298.206 40.9584 298.206Z",
    fill: "#00BA9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9584 293.216C40.5426 293.216 40.1268 293.549 40.1268 294.048V300.95H41.79V294.048C41.79 293.549 41.4574 293.216 40.9584 293.216Z",
    fill: "#7AFFEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7048 286.064C42.7048 286.979 41.9564 287.811 40.9584 287.811C40.0437 287.811 39.2952 286.979 39.2952 286.064C39.2952 285.15 40.0437 284.318 41.0416 284.318C41.9564 284.401 42.7048 285.15 42.7048 286.064Z",
    fill: "#06594C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2121 314.921C40.9584 314.921 42.289 313.507 42.289 311.844C42.289 310.098 40.8753 308.767 39.2121 308.767H39.0457C38.3805 307.021 36.7172 305.857 34.8046 305.857C32.3098 305.857 30.2308 307.936 30.2308 310.43H29.5655C28.3181 310.43 27.237 311.428 27.237 312.759C27.237 314.006 28.2349 315.087 29.5655 315.087H30.2308",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7048 314.921C40.9584 314.921 39.6279 313.507 39.6279 311.844C39.6279 310.098 41.0416 308.767 42.7048 308.767H42.8711C43.5364 307.021 45.1996 305.857 47.1123 305.857C49.6071 305.857 51.6861 307.936 51.6861 310.43H52.3514C53.5988 310.43 54.6798 311.428 54.6798 312.759C54.6798 314.006 53.6819 315.087 52.3514 315.087H51.7692",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 311.262V313.175C21 314.505 22.0811 315.586 23.4116 315.586H58.5052C59.8358 315.586 60.9168 314.505 60.9168 313.175V311.262H21Z",
    fill: "#03CFAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5343 306.771C44.5343 308.767 42.9542 310.347 40.9584 310.347C38.9625 310.347 37.3825 308.767 37.3825 306.771C37.3825 304.775 38.9625 303.195 40.9584 303.195C42.9542 303.195 44.5343 304.775 44.5343 306.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9584 301.532C40.2931 301.532 39.711 302.114 39.711 302.78V306.106C39.711 306.771 40.2931 307.353 40.9584 307.353C41.6237 307.353 42.2058 306.771 42.2058 306.106V302.78C42.2058 302.114 41.7068 301.532 40.9584 301.532Z",
    fill: "white"
  }))), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M507.503 109.998C529.869 109.998 548 91.8664 548 69.4994C548 47.1319 529.869 29 507.503 29C485.131 29 467 47.1319 467 69.4994C467 91.8664 485.131 109.998 507.503 109.998Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_126:84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.132 78.0803V84.729C504.132 84.9412 504.132 85.0827 504.132 85.2949H511.791C511.791 85.1534 511.791 84.9412 511.791 84.729V78.0803H504.132Z",
    fill: "#03CFAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.533 78.8583C524.533 79.4949 524.032 80.0608 523.316 80.0608H492.75C492.106 80.0608 491.533 79.5656 491.533 78.8583V57.851C491.533 57.1437 492.034 56.6486 492.75 56.6486H523.388C524.032 56.6486 524.605 57.1437 524.605 57.851V78.8583H524.533Z",
    fill: "#03CFAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.533 74.4022V78.929C491.533 79.5656 492.034 80.1315 492.75 80.1315H523.388C524.032 80.1315 524.605 79.6364 524.605 78.929V74.4022H491.533Z",
    fill: "#007E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.414 84.9413H513.724",
    stroke: "#007E6B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.433 67.1169C509.357 67.1169 507.353 67.1169 505.277 67.1169C504.919 65.7022 504.49 64.3583 504.132 62.9437C506.923 62.9437 509.787 62.9437 512.579 62.9437C512.221 64.3583 511.863 65.773 511.433 67.1169Z",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.349 67.1169L503.702 61.3169L501.984 61.2461",
    stroke: "white",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.422 68.2486C505.993 68.2486 505.635 68.6022 505.635 69.0266C505.635 69.451 505.993 69.8047 506.422 69.8047C506.852 69.8047 507.21 69.451 507.21 69.0266C507.21 68.6022 506.852 68.2486 506.422 68.2486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.216 68.2486C509.787 68.2486 509.429 68.6022 509.429 69.0266C509.429 69.451 509.787 69.8047 510.216 69.8047C510.646 69.8047 511.004 69.451 511.004 69.0266C511.004 68.6022 510.646 68.2486 510.216 68.2486Z",
    fill: "white"
  }))), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M589.63 282.253C612.067 282.253 630.255 264.064 630.255 241.627C630.255 219.189 612.067 201 589.63 201C567.188 201 549 219.189 549 241.627C549 264.064 567.188 282.253 589.63 282.253Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_126:84)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608 238.415V228.528H598.113L608 238.415Z",
    fill: "#03CFAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.736 231.17L592.679 240.226L589.132 236.604L572 253.736V258.189V260.906L589.132 243.774L592.679 247.396L605.283 234.792L601.736 231.17Z",
    fill: "#03CFAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.679 233.887V224H582.792L592.679 233.887Z",
    fill: "#007E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.321 225.811L578.264 234.792L574.717 231.17L572 233.887V241.132L574.717 238.415L578.264 242.038L590.868 229.434L587.321 225.811Z",
    fill: "#007E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.377 259.094V249.208H594.491L604.377 259.094Z",
    fill: "#0FF9D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.566 254.566L599.019 251.019L589.132 260.906H596.302L602.566 254.566Z",
    fill: "#0FF9D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_126:84",
    x1: 351.473,
    y1: 160.918,
    x2: 351.473,
    y2: 214.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70FCE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_126:84",
    x1: 179.32,
    y1: 160.418,
    x2: 179.32,
    y2: 214.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96FBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06594C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_126:84",
    x1: 270.211,
    y1: 160.418,
    x2: 270.211,
    y2: 214.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96FBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03CFAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_126:84",
    x1: 328.347,
    y1: 73.8413,
    x2: 328.347,
    y2: 155.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96FBEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06594C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_126:84",
    x1: 305.505,
    y1: 280.19,
    x2: 305.505,
    y2: 291.056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BA9C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_126:84",
    x1: 167.455,
    y1: 300.874,
    x2: 212.023,
    y2: 283.891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_126:84",
    x1: 224.164,
    y1: 276.204,
    x2: 264.219,
    y2: 251.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_126:84",
    x1: 234.384,
    y1: 265.474,
    x2: 239.358,
    y2: 263.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D60221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC6300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_126:84",
    x1: 136.296,
    y1: 269.929,
    x2: 161,
    y2: 261.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_126:84",
    x1: 185.027,
    y1: 245.704,
    x2: 211.828,
    y2: 454.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FDABC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_126:84",
    x1: 209.705,
    y1: 73.8413,
    x2: 209.705,
    y2: 155.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#036F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70FCE6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126:84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 39.9165,
    fill: "white",
    transform: "translate(102 21)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_126:84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 38.5863,
    fill: "white",
    transform: "translate(21 277)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_126:84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 29,
    fill: "white",
    transform: "translate(491.533 56.6486)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_126:84"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36.9057,
    fill: "white",
    transform: "translate(572 224)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLoginIllustration);
export default __webpack_public_path__ + "static/media/mainLoginIllustration.9ea0c2eb77aa817107f8bee7936fc358.svg";
export { ForwardRef as ReactComponent };